export enum TagColor {
    blueSapphire = "blueSapphire",
    islamicGreen = "islamicGreen",
    MaximumPurple = "MaximumPurple",
    MediumSlateBlue = "MediumSlateBlue",
    Prune = "Prune",
    RoyalFuchsia = "RoyalFuchsia",
    RussianViolet = "RussianViolet",
    RustyRed = "RustyRed",
    blackPearl = "blackPearl",
    DarkOchre = "DarkOchre",
    RawSienna = "RawSienna",
    BurntAmber = "BurntAmber",
    TigerEye = "TigerEye",
    DeepSeaBlue = "DeepSeaBlue",
    Gunmetal = "Gunmetal",
    DustyRose = "DustyRose",
    IndigoDye = "IndigoDye",
    BrickRed = "BrickRed",
    DarkOliveDrab = "DarkOliveDrab",
}

const RESERVED_COLORS = [TagColor.RustyRed];
export const LABEL_COLORS = Object.values(TagColor).filter(
    (c) => !RESERVED_COLORS.includes(c),
);

export const extractRandomLabelTagColor = (): TagColor => {
    const randomIndex = Math.floor(Math.random() * LABEL_COLORS.length);
    return LABEL_COLORS[randomIndex] as TagColor;
};

/*{
    blueSapphire: 'blueSapphire',
    islamicGreen: 'islamicGreen',
    MaximumPurple: 'MaximumPurple',
    MediumSlateBlue: 'MediumSlateBlue',
    Prune: 'Prune',
    RoyalFuchsia: 'RoyalFuchsia',
    RussianViolet: 'RussianViolet',
    RustyRed: 'RustyRed'
}*/
